import React from "react";
import { useState, useEffect, useLayoutEffect } from "react";
import { FxmsData } from "../fxms/datas/FxData";
import { DetailModal } from './VupComDash_1'
import { v4 as uuidv4 } from 'uuid';
import "./../css/VUP_dash.css";

export const SensorTable = (props) => {
  const [arr, setArr] = useState([]);

  const complexInloNo = props.complexInloNo;
  const inputDatas = {'complexInloNo':complexInloNo}
  const energy = FxmsData.getDatas("energy");
  const [clickedEng, setClickedEng] = useState("");
  const [clickedCnt, setClickedCnt] = useState("");
  const [modal, setModal] = useState(false);

  function clickHandler(click_id, click_cnt) {
    setClickedEng(click_id);
    setClickedCnt(click_cnt);
    setModal(!modal);
  }

  async function showTable() {
    const uri = "vup/dash/sensor/state";
    try {
      const res = await FxmsData.get(uri, inputDatas)

      let datas = [];
      for ( let eng of energy ) {
        let values = null;
        for( let val of res.data.sensor_state_list) {
          if ( eng.engId === val.engId ) {
            values = { ... val};
            values.engName = eng.engName;
            values.engDescr = eng.engDescr;
            break;
          }
        }
        if (values == null) {
          values = { engId: eng.engId, engName: eng.engName, totCnt: 0, onCnt: 0, offCnt: 0 };
        }
        datas.push(values);
        setArr(datas);
      }
    } catch (e) {
      console.log(" error e : " + e);
    }
  }
  useEffect(()=> {
    showTable();
  }, []);

  /*useLayoutEffect(() => {
    const interval = setInterval(() => {
      showTable();
    }, 60000);

    return () => clearInterval(interval);
  }, []);*/

  return (
    <>
    <div className="tableData" key={uuidv4()}>
      <table>
      <caption>계측기</caption>
        <tbody>
        <tr key={uuidv4()}>
          <th key={uuidv4()}>에너지 종류</th>
          <th key={uuidv4()}>전체</th>
          <th key={uuidv4()}>정상</th>
          <th key={uuidv4()}>이상</th>
        </tr>
        {arr.map((data)=> (
          <tr key={uuidv4()}>
          <td key={uuidv4()}>
            {data.engName}
          </td>
          <td key={uuidv4()}><a href="#" onClick={() => clickHandler(data.engId,"totalCnt")}>
            {data.totCnt}</a>
          </td>
          <td key={uuidv4()}><a href="#" onClick={() => clickHandler(data.engId,"onCnt")}>
            {data.onCnt}</a>
          </td>
          <td key={uuidv4()}><a href="#" onClick={() => clickHandler(data.engId,"offCnt")}>
            {data.offCnt}</a>
          </td>
        </tr>
        ))}
      </tbody>
      </table>
      {modal && (
        <DetailModal engId={clickedEng}  cnt={clickedCnt} setModal={setModal} open={true} complexInloNo={complexInloNo} />
      )}
    </div>
    </>
  )
}